const MEMBER_LIST_COLUMNS = 'id:user_id, first_name, last_name, role, status, birth_date, city, market_id, assigned_concierge_id, is_ambassador, archived_at, activated_at, last_touch_at';

const LIST_MEMBER_FIELDS = `${MEMBER_LIST_COLUMNS}, clients(payment_status, is_comped)`;

const BILLING_MEMBER_FIELDS = `${MEMBER_LIST_COLUMNS}, clients!inner(payment_status, is_comped)`;

const MEMBER_VISIBILITY_FIELDS = 'id, member_visible';

const SEARCH_MEMBER_COLUMNS = ['first_name', 'last_name', 'email'] as const;

export {
  BILLING_MEMBER_FIELDS,
  LIST_MEMBER_FIELDS,
  MEMBER_VISIBILITY_FIELDS,
  SEARCH_MEMBER_COLUMNS,
};
